
export const getStateByPath = (state = [], path) => {
    return state?.indexedProps?.find(s => s.path === path);
}